import AppLayout from '@/shared/tailadmin/layout/AppLayout';

/**
 * The frame every page sits in.
 *
 * ⚠️ **This is TailAdmin's own `AppLayout`, not a rebuild of it.** An earlier pass copied the
 * template's design into hand-written widgets, which meant every fix the template ever ships has to
 * be re-derived by hand and every component in `shared/tailadmin/` renders against a shell it was
 * not written for. Using the file the components were built against is the difference between
 * adopting a template and being inspired by one.
 *
 * What it gives: a rail that collapses to icons and widens on hover, its own mobile drawer and
 * backdrop, a sticky header carrying search, notifications and the account menu, and a content
 * column bounded at `--breakpoint-2xl`.
 *
 * ⚠️ Three things were changed inside it rather than around it, because they are wrong for THIS
 * product rather than wrong in general — each is documented where it lives:
 *   • `layout/AppSidebar.tsx` — the association's four screens above the template's demo pages,
 *     labelled from the dictionary so §23.10's runtime language flip reaches them.
 *   • `context/ThemeContext.tsx` — `useTheme` delegates to the panel's appearance setting, so the
 *     template's toggle drives the §7 palette instead of a `.dark` class nothing reads.
 *   • `router-compat.tsx` — `react-router`'s `Link`, `Outlet` and `useNavigate` implemented on
 *     TanStack Router, so the fifteen template files that import them keep working against one
 *     history rather than two.
 */
export function AppShell() {
  return <AppLayout />;
}
